import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.5 4.167c-.92 0-1.667.746-1.667 1.666v8.334a3.333 3.333 0 0 1-6.666 0v-5a.833.833 0 1 1 1.666 0v5a1.667 1.667 0 0 0 3.334 0V5.833a3.333 3.333 0 1 1 6.666 0V10a.833.833 0 0 1-1.666 0V5.833c0-.92-.747-1.666-1.667-1.666",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.72 2.9a.833.833 0 0 0-1.44 0L2.814 5.414a.833.833 0 0 0 .72 1.254h2.932a.833.833 0 0 0 .72-1.254zM12.5 15a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
    }, null, -1)
  ])))
}
export default { render: render }